import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true }; // Update state so the next render shows fallback UI
  }

  componentDidCatch(error, errorInfo) {
    console.error("Error captured in ErrorBoundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <div>Market data is temporarily unavailable.</div>;
    }
    return this.props.children; 
  }
}

export default ErrorBoundary;
